"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleTracking = handleTracking;
function handleTracking(trackingData) {
    const customEventData = new CustomEvent('pulsar', {
        detail: [trackingData, { actionKind: trackingData.actionKind }],
    });
    document.dispatchEvent(customEventData);
}
